import Config from '../../AppConfig';
import { get } from './core/fetch';

export const getDetails = async (adviserId?: string): Promise<any> => {
	const queryParam = adviserId ? `?userId=${adviserId}` : '';
	return await get(
		`${Config.mlcApiPrefix.replace('v1', 'v2')}/identity${queryParam}`,
		{
			withAuth: true,
			noGateway: false,
		}
	);
};
